import React, { useState } from 'react';
import { Mail, Phone, User, MapPin, ExternalLink, Copy, Check } from 'lucide-react';
import './Contact.css';

const CONTACT = {
  name: 'Rafał Łopatka',
  email: 'rafal.lopatka@rafloor.pl',
  phone: '+48 512 280 787',
  address: 'Mrowino ul. Dobrowita 34 62-090',
  mapsQuery: 'Mrowino ul. Dobrowita 34 62-090',
};

const Contact = () => {
  const [copied, setCopied] = useState(null); // 'name' | 'email' | 'phone' | 'address' | null

  const copyToClipboard = async (value, key) => {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(value);
      } else {
        // Fallback dla starszych przeglądarek
        const ta = document.createElement('textarea');
        ta.value = value;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }
      setCopied(key);
      setTimeout(() => setCopied(null), 1600);
    } catch (e) {
      console.error('Nie udało się skopiować do schowka', e);
    }
  };

  const mapHref = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    CONTACT.mapsQuery
  )}`;

  return (
    <div className="contact-page">
      {/* HERO */}
      <section className="contact-hero">
        <div className="contact-hero__content">
          <h1>Kontakt</h1>
          <p className="contact-hero__subtitle">
            Skontaktuj się z nami — odpowiadamy szybko i konkretnie.
          </p>
          <div className="contact-hero__actions">
            <a href={`mailto:${CONTACT.email}`} className="btn btn-primary">Napisz e-mail</a>
            <a href={`tel:${CONTACT.phone.replace(/\s+/g, '')}`} className="btn btn-secondary">Zadzwoń</a>
          </div>
        </div>

        <div className="contact-hero__decor">
          <div className="contact-hero__bubble contact-hero__bubble--a animate-float" />
          <div className="contact-hero__bubble contact-hero__bubble--b animate-float-delayed" />
          <div className="contact-hero__bubble contact-hero__bubble--c animate-float" />
        </div>
      </section>

      {/* PROSTA LISTA DANYCH */}
      <section className="contact-simple section">
        <div className="container">
          <h2 className="section-title">Dane kontaktowe</h2>

          <dl className="contact-details">
            {/* Osoba */}
            <div className="contact-item">
              <dt>
                <User size={18} aria-hidden="true" />
                <span>Osoba kontaktowa</span>
              </dt>
              <dd>
                <span className="contact-value">{CONTACT.name}</span>
                <button
                  className={`copy-btn ${copied === 'name' ? 'copied' : ''}`}
                  onClick={() => copyToClipboard(CONTACT.name, 'name')}
                  aria-label="Skopiuj imię i nazwisko"
                  title="Skopiuj"
                >
                  {copied === 'name' ? <Check size={16} /> : <Copy size={16} />}
                  <span className="copy-label">{copied === 'name' ? 'Skopiowano' : 'Kopiuj'}</span>
                </button>
              </dd>
            </div>

            {/* E-mail */}
            <div className="contact-item">
              <dt>
                <Mail size={18} aria-hidden="true" />
                <span>E-mail</span>
              </dt>
              <dd>
                <a href={`mailto:${CONTACT.email}`} className="contact-link contact-value">
                  {CONTACT.email}
                </a>
                <button
                  className={`copy-btn ${copied === 'email' ? 'copied' : ''}`}
                  onClick={() => copyToClipboard(CONTACT.email, 'email')}
                  aria-label="Skopiuj e-mail"
                  title="Skopiuj"
                >
                  {copied === 'email' ? <Check size={16} /> : <Copy size={16} />}
                  <span className="copy-label">{copied === 'email' ? 'Skopiowano' : 'Kopiuj'}</span>
                </button>
              </dd>
            </div>

            {/* Telefon */}
            <div className="contact-item">
              <dt>
                <Phone size={18} aria-hidden="true" />
                <span>Telefon</span>
              </dt>
              <dd>
                <a
                  href={`tel:${CONTACT.phone.replace(/\s+/g, '')}`}
                  className="contact-link contact-value"
                >
                  {CONTACT.phone}
                </a>
                <button
                  className={`copy-btn ${copied === 'phone' ? 'copied' : ''}`}
                  onClick={() => copyToClipboard(CONTACT.phone, 'phone')}
                  aria-label="Skopiuj numer telefonu"
                  title="Skopiuj"
                >
                  {copied === 'phone' ? <Check size={16} /> : <Copy size={16} />}
                  <span className="copy-label">{copied === 'phone' ? 'Skopiowano' : 'Kopiuj'}</span>
                </button>
              </dd>
            </div>

            {/* Adres */}
            <div className="contact-item">
              <dt>
                <MapPin size={18} aria-hidden="true" />
                <span>Adres</span>
              </dt>
              <dd>
                <a href={mapHref} target="_blank" rel="noreferrer" className="contact-link contact-value">
                  {CONTACT.address}
                </a>
                <a href={mapHref} target="_blank" rel="noreferrer" className="open-map" aria-label="Otwórz w Mapach" title="Otwórz w Mapach">
                  <ExternalLink size={16} />
                </a>
                <button
                  className={`copy-btn ${copied === 'address' ? 'copied' : ''}`}
                  onClick={() => copyToClipboard(CONTACT.address, 'address')}
                  aria-label="Skopiuj adres"
                  title="Skopiuj"
                >
                  {copied === 'address' ? <Check size={16} /> : <Copy size={16} />}
                  <span className="copy-label">{copied === 'address' ? 'Skopiowano' : 'Kopiuj'}</span>
                </button>
              </dd>
            </div>
          </dl>
        </div>
      </section>
    </div>
  );
};

export default Contact;
